import type ApplicationModel from 'components/framework/ApplicationModel';
import { PageAction } from '../PageAction';
import { type RemoteAttributes } from '../RecordAction';
import { Page } from 'components/framework/models';

export class EditLinkAction extends PageAction {
  documentTypes = [Page.DOCUMENT_TYPE_EXTERNAL_LINK];
  isRemoteLink = true;

  get title() {
    return 'Edit link';
  }

  remoteLinkAttributes(records): RemoteAttributes {
    const record = records[0];
    const { referenceNum, isPersonal } = record;
    const prefix = isPersonal ? 'user/pages' : 'pages';

    return {
      href: `/${prefix}/${referenceNum}/edit`,
      method: 'get',
    };
  }

  showForRecord(record: ApplicationModel): record is Page {
    return (
      super.showForRecord(record) &&
      record.permissions?.update !== false &&
      this.selectedRecords.length === 1
    );
  }
}
